import React from "react";
import CapsuleImageVertical from "../../Components/CapsuleImageVertical/CapsuleImageVertical";
import SectionTwoImage from "../../Assets/Images/ab-1.png";
import SectionTwoImageMobile from "../../Assets/Images/ab-mobile-img-1.png";
import iambestImage from "../../Assets/Images/am-best.svg";
import { useTranslation } from "../../Hooks/useTranslation"; // Import the hook

const AmBest = () => {
  const translations = useTranslation(); // Get translations dynamically
  return (
    <>
      <div className="flex-1">
        <div className="hidden lg:block">
          <CapsuleImageVertical image={SectionTwoImage} />
        </div>
        <div className="mt-8 mb-4 lg:hidden flex justify-center">
          <img
            src={SectionTwoImageMobile}
            alt="section-two-image-mobile"
            className="w-full"
          />
        </div>
      </div>

      <div className="flex-1 mt-2 lg:mt-32 animate__animated animate__fadeIn lg:pl-0 px-4">
        <h3 className="md:text-[24px] font-semibold mb-4 text-[16px] leading-[20px] md:leading-[28px] extra-title36">
          {translations.AmBestTitle}
        </h3>

        <p
          className="text-[14px] leading-[22px] mb-2 text-justify extra-para-vs"
          dangerouslySetInnerHTML={{
            __html: translations.AmBestDescription1,
          }}
        ></p>
        <p className="text-[14px] leading-[22px] mb-2 text-justify extra-para-vs">
          {translations.AmBestDescription2}
        </p>
        <img
          src={iambestImage}
          className="max-w-[150px] max-h-[150px] mt-10 hidden lg:block iambest-logo"
          alt="iambest-logo"
        />
      </div>
    </>
  );
};

export default AmBest;
